import React from 'react'
import { BOOKMAKER_LOGOS } from '../config/bookmakers'
import { MARKET_TYPE_MAPPING } from '../config/markets'

const formatMarketType = (mt) => {
  if (MARKET_TYPE_MAPPING[mt]) return MARKET_TYPE_MAPPING[mt]
  return (mt || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

const formatDate = (ts) =>
  new Date(ts + 'Z').toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true,
  })

// ARB track form shape:
//   sport, match, market_type (all readonly)
//   bookmaker, bookmaker2 (readonly — both sides)
//   selection1, selection2 (readonly)
//   stake (editable — total stake)
//   profit (editable — optional, fills in if settled)

export default function TrackBetModal({ isOpen, opp, form, onFormChange, onConfirm, onConfirmAndHide, onClose }) {
  if (!isOpen || !opp) return null

  const patch = (field, val) => onFormChange({ ...form, [field]: val })

  return (
    <>
      <div className="bc-overlay" onClick={onClose} />
      <div className="ptm-modal">

        {/* Header */}
        <div className="ptm-header">
          <span className="ptm-title">Track ARB Bet</span>
          <button className="bc-panel-close" onClick={onClose}>×</button>
        </div>

        {/* Info card — match + market + game time */}
        <div className="ptm-info-card">
          <div className="ptm-info-body">
            <div className="ptm-player-row">
              <span className="ptm-player-name">{opp.match}</span>
            </div>
            <div className="ptm-info-market">{formatMarketType(opp.market_type)}</div>
            {opp.commence_time && (
              <div className="ptm-info-meta">{formatDate(opp.commence_time)}</div>
            )}

            {/* Two outcome rows */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '10px' }}>
              {[
                { sel: form.selection1, book: form.bookmaker },
                { sel: form.selection2, book: form.bookmaker2 },
              ].map(({ sel, book }, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', background: 'rgba(51,65,85,0.5)', borderRadius: '6px', border: '1px solid #334155' }}>
                  {BOOKMAKER_LOGOS[book]
                    ? <img src={BOOKMAKER_LOGOS[book]} alt={book} style={{ width: '22px', height: '22px', borderRadius: '4px', flexShrink: 0 }} />
                    : <span style={{ fontSize: '10px', color: '#64748b', fontWeight: 700, minWidth: '22px' }}>{(book || '').slice(0, 2).toUpperCase()}</span>
                  }
                  <span style={{ fontSize: '12px', color: '#cbd5e1', fontWeight: 500 }}>{sel}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="ptm-form">

          {/* Stake + Profit */}
          <div className="ptm-form-row">
            <div className="ptm-field">
              <label className="ptm-label">Total Stake ($)</label>
              <input
                type="number"
                min="0"
                step="1"
                placeholder="e.g. 200"
                value={form.stake ?? ''}
                onChange={e => patch('stake', e.target.value)}
                className="ptm-input"
              />
            </div>
            <div className="ptm-field">
              <label className="ptm-label">Profit ($) <span style={{ color: '#475569', fontWeight: 400 }}>optional</span></label>
              <input
                type="number"
                step="0.01"
                placeholder="e.g. 15.50"
                value={form.profit ?? ''}
                onChange={e => patch('profit', e.target.value)}
                className="ptm-input"
              />
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="ptm-footer">
          <button className="bc-btn ghost" onClick={onClose}>Cancel</button>
          <div className="ptm-footer-right">
            <button className="bc-btn danger" onClick={onConfirmAndHide}>Track & Hide</button>
            <button className="bc-btn primary" onClick={onConfirm}>Track</button>
          </div>
        </div>

      </div>
    </>
  )
}
